import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {Dialog, DialogActions, DialogBody, DialogTitle} from "../catalyst/dialog";
import TextInput from "../form/TextInput";
import {Button} from "../catalyst/button";
import {useEffect, useState} from "react";
import {BuildingStorefrontIcon, ChevronUpDownIcon, InformationCircleIcon} from "@heroicons/react/16/solid";
import {fetchAccomodations, setCurrentHotel, setCurrentHotelObject} from "../../store/slices/hotelsSlice";
import {useTranslation} from "react-i18next";

export default function DialogHotelSelector() {

    const { t } = useTranslation()

    const {
        currentHotel,
        accommodations,
        fetchingHotels
    } = useSelector((state: RootState) => state.hotels)

    const dispatch = useDispatch()

    const [showDialog, setShowDialog] = useState<boolean>(false)
    const [search, setSearch] = useState<string>('')

    function getSelectedAccomodation () {
        if (currentHotel && accommodations) {
            const accomodation = accommodations.find(a => a.idAccomodation === currentHotel)
            if (accomodation) {
                return {
                    label: accomodation.accomodationName,
                    value: accomodation.idAccomodation,
                    active: accomodation.isActive
                }
            }
        }
        return undefined
    }

    function getTopAccommodations () {
        if (search && search !== '' && search !== null && search !== undefined) {
            return accommodations.filter(a => {
                return a.accomodationName.toLowerCase().indexOf(search.toLowerCase()) > -1
            }).slice(0, 10).map( a => {
                return {
                    label: a.accomodationName,
                    value: a.idAccomodation,
                    active: a.isActive
                }
            })
        }

        if (accommodations && accommodations.length > 0) {
            return accommodations.slice(0, 10).map( a => {
                return {
                    label: a.accomodationName,
                    value: a.idAccomodation,
                    active: a.isActive
                }
            })
        }
        return []
    }

    useEffect(() => {
        if (!accommodations || accommodations.length === 0) {
            dispatch(fetchAccomodations())
        }
    }, [])

    useEffect(() => {
        if (!currentHotel && accommodations && accommodations.length > 0) {
            dispatch(setCurrentHotel(accommodations[0].idAccomodation))
            dispatch(setCurrentHotelObject(accommodations[0]))
        }
    }, [ accommodations ])

    return (
        <div>
            <button onClick={() => setShowDialog(true)} className="border w-full md:border-0 text-left mb-4 md:mb-0 flex items-center overflow-hidden hover:bg-slate-50 p-2 rounded-md">
                <div className={'text-gray-600 mr-2'}>
                    <BuildingStorefrontIcon className={'h-5'} />
                </div>
                <div className="flex-1 text-slate-600 font-medium text-sm">
                    {getSelectedAccomodation()?.label || t('hotelSelector.selectHotel')}
                </div>
                <div>
                    <ChevronUpDownIcon className={'text-slate-600 ml-2 h-5'} />
                </div>
            </button>

            <Dialog open={showDialog} onClose={() => setShowDialog(false)} className={'p-0'}>
                <DialogTitle className={'p-4 pb-0 m-0'}>{t('hotelSelector.selectHotel')}</DialogTitle>
                <DialogBody className={'m-0 p-0 mt-0'}>
                    <div className="bg-slate-100 p-4">
                        <TextInput value={search} placeholder={t('hotelSelector.search')} clearable={true} onChange={val => setSearch(val)}/>
                    </div>

                    <div className={'text-slate-600 font-medium p-4'}>
                        Elenco strutture
                    </div>

                    <div className={'flex flex-col'}>
                        {fetchingHotels && 'Carico le strutture associate'}
                        {getTopAccommodations().map(accommodation => (
                            <button onClick={() => {
                                dispatch(setCurrentHotel(accommodation.value))
                                const hotel = accommodations?.find(h => h.idAccomodation === accommodation.value)
                                if (hotel) dispatch(setCurrentHotelObject(hotel))
                                setShowDialog(false)
                            }} className={`${!accommodation.active && 'opacity-30'} text-left cursor-pointer px-4 p-2 hover:bg-orange-100 hover:text-orange-600`}>
                                {accommodation.label}
                            </button>
                        ))}
                    </div>

                    <div className="flex p-4 bg-slate-100 text-slate-700 space-x-4">
                        <div>
                            <InformationCircleIcon className={'h-5'} />
                        </div>
                        <div className={'flex-1'}>
                            {t('hotelSelector.disclaimer')}
                        </div>
                    </div>
                </DialogBody>
                <DialogActions className={'px-4 pb-4'}>
                    <Button plain onClick={() => setShowDialog(false)}>
                        {t('general.cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )

}